// dsi18n('Addthestore'), 返回的对应的是美杜莎appname是dropshipping-saas，key是dropshipping-saas.Addthestore的文案
const dsi18n = (key: string) => {
  // window.i18nDsSaas是从VM中直接注入的
  // 获取的美杜莎appname是：dropshipping-saas
  // 获取的美杜莎key的namespace是：dropshipping-saas，例如dropshipping-saas.Addthestore、dropshipping-saas.Searchproductsin
  // 内容中心的namespace是 dropshipping-buyercentral, 如：dropshipping-buyercentral.headline.HowToStart.Step2Desc
  let pre = 'dropshipping-saas';
  if (window.i18nPreKey) {
    pre = 'dropshipping-buyercentral';
  }
  
  return window?.i18nDsSaas[`${pre}.${key}`] || `待翻译key:${key}`;
};

export default dsi18n;
